import {
  aCustomInsight,
  aCustomInsightPage,
  aDynamicInsightSeverity,
  CustomInsight,
  mockCustomInsightQueryQuery,
  mockCustomInsightsQueryOperationQuery,
} from '__generated__';

const baseCustomInsightOverrides: Partial<CustomInsight> = {
  dynamicSeverity: [
    aDynamicInsightSeverity({
      minimumSignalSeverity: 0,
    }),
  ],
};

export const getMockCustomInsightQueryQuery_update = (
  customInsight: Partial<CustomInsight>
) => {
  return mockCustomInsightQueryQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        customInsight: aCustomInsight({
          id: '0',
          ...baseCustomInsightOverrides,
          ...customInsight,
        }),
      })
    );
  });
};

export const getMockCustomInsightQueryOperationQuery_create = (
  customInsight: Partial<CustomInsight>
) => {
  return mockCustomInsightsQueryOperationQuery((_req, res, ctx) => {
    const customInsights = aCustomInsightPage().objects;
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        customInsights: aCustomInsightPage({
          objects: [
            ...customInsights,
            aCustomInsight({
              id: '0',
              ...baseCustomInsightOverrides,
              ...customInsight,
            }),
          ],
        }),
      })
    );
  });
};

export const handlers = [
  mockCustomInsightQueryQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        customInsight: aCustomInsight(),
      })
    );
  }),
  mockCustomInsightsQueryOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        customInsights: aCustomInsightPage(),
      })
    );
  }),
];
